const RedirectUser = () => {
  window.location.replace('/user');
  return (<div />);
};
export { RedirectUser };
